import { render, staticRenderFns } from "./my-customer.vue?vue&type=template&id=779c0766&lang=pug&"
import script from "./my-customer.vue?vue&type=script&lang=js&"
export * from "./my-customer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports